import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ea9cc4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"90vh","background-color":"white"} }
const _hoisted_2 = { style: {"height":"0.5vh"} }
const _hoisted_3 = { class: "p-mt-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"20px"},
  class: "pi pi-globe"
}, null, -1))
const _hoisted_5 = { class: "p-mx-1" }
const _hoisted_6 = { class: "p-mx-1" }
const _hoisted_7 = { class: "p-mx-1" }
const _hoisted_8 = { class: "p-mx-1" }
const _hoisted_9 = {
  class: "p-col-12",
  style: {"height":"8vh"}
}
const _hoisted_10 = { style: {"height":"72vh","overflow":"hidden","background-color":"#fff"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, " No tokens issued today ", -1))
const _hoisted_12 = { class: "token-badge" }
const _hoisted_13 = { style: {"display":"flex","gap":"4px","align-items":"center","min-width":"140px"} }
const _hoisted_14 = {
  style: {"height":"10vh"},
  class: "p-grid p-m-0 p-p-0"
}
const _hoisted_15 = { class: "set-bottom-amt p-col" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Date")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "set-bottom-amt p-col" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Pending")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "set-bottom-amt p-col" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Completed")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = { class: "set-bottom-amt p-col" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Total Issued")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { class: "confirmation-content" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem","color":"#e67e22"}
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-content" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-exclamation-triangle p-mr-3",
    style: {"font-size":"2rem","color":"#c0392b"}
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Are you sure you want to cancel this order? The token will be abandoned and cannot be recovered.")
], -1))
const _hoisted_30 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No activity records found", -1))
const _hoisted_33 = { class: "confirmation-content" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PaymentScreen = _resolveComponent("PaymentScreen")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.progressBar)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              style: {"height":"0.2em"}
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Toolbar, { style: {"height":"7.5vh"} }, {
        start: _withCtx(() => [
          _createElementVNode("h5", _hoisted_3, [
            _createElementVNode("b", null, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.storeName), 1)
            ])
          ])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.selectedStatusType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedStatusType) = $event)),
              options: _ctx.statusTypes,
              optionLabel: "name",
              optionValue: "key",
              onChange: _ctx.loadList
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Calendar, {
              modelValue: _ctx.selectedDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDate) = $event)),
              dateFormat: "yy-mm-dd",
              showIcon: true,
              maxDate: new Date(),
              placeholder: "Select date",
              onDateSelect: _ctx.onDateChange,
              style: {"width":"160px"}
            }, null, 8, ["modelValue", "maxDate", "onDateSelect"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Button, {
              icon: "pi pi-refresh",
              label: "Refresh",
              class: "p-button-warning",
              onClick: _ctx.loadList
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              icon: "pi pi-power-off",
              label: "Cashier Logout (End)",
              class: "p-button-danger",
              onClick: _ctx.logoutCashier,
              id: "logoutBtn"
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_InputText, {
          modelValue: _ctx.keyword,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.keyword) = $event)),
          modelModifiers: { trim: true },
          placeholder: "SCAN OR SEARCH TOKEN NUMBER",
          id: "token-search",
          onKeydown: _withKeys(_ctx.searchToken, ["enter"]),
          class: "w-full",
          autoFocus: ""
        }, null, 8, ["modelValue", "onKeydown"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_DataTable, {
          first: _ctx.goToFirstLink,
          "onUpdate:first": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
          value: _ctx.lists,
          dataKey: "id",
          ref: "dt",
          paginator: true,
          rows: _ctx.limit,
          totalRecords: _ctx.totalRecords,
          resizableColumns: true,
          columnResizeMode: "expand",
          responsiveLayout: "scroll",
          class: "p-datatable-sm p-datatable-striped p-datatable-gridlines token-queue-table",
          rowClass: _ctx.rowClass,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
          onPage: _ctx.onPageChange
        }, {
          empty: _withCtx(() => [
            _hoisted_11
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "Token #",
              style: {"width":"80px","min-width":"80px"}
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(String(slotProps.data.display_number)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Token Code",
              style: {"width":"150px","min-width":"150px"}
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.token_number), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Account Title",
              style: {"width":"130px","min-width":"130px"}
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.customer_name || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Total Amount",
              style: {"width":"110px","min-width":"110px"}
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(slotProps.data.total_bill).toFixed(2)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Items",
              style: {"width":"80px","min-width":"80px"}
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.items?.length || 0) + " item(s) ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Last Accessed By",
              style: {"width":"120px","min-width":"120px"}
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.getStatusUser(slotProps.data)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Status",
              style: {"width":"100px","min-width":"100px"}
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", {
                  class: _normalizeClass('status-badge status-' + (slotProps.data.status_label || ''))
                }, _toDisplayString((slotProps.data.status_label || 'unknown').toUpperCase()), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Action",
              class: "action-cell"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_13, [
                  (slotProps.data.status === 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_Button, {
                          icon: "pi pi-dollar",
                          class: "p-button-success p-button-rounded p-button-sm",
                          onClick: ($event: any) => (_ctx.loadCart(slotProps.data.token_number))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_Button, {
                          icon: "pi pi-pencil",
                          class: "p-button-warning p-button-rounded p-button-sm",
                          onClick: ($event: any) => (_ctx.editCart(slotProps.data.id))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_Button, {
                          icon: "pi pi-times",
                          class: "p-button-danger p-button-rounded p-button-sm",
                          onClick: ($event: any) => (_ctx.cancelToken(slotProps.data.id))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_Button, {
                          icon: "pi pi-print",
                          class: "p-button-info p-button-rounded p-button-sm",
                          onClick: ($event: any) => (_ctx.reprintSlip(slotProps.data.id))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_Button, {
                          icon: "pi pi-eye",
                          class: "p-button-rounded p-button-success p-mr-2",
                          onClick: ($event: any) => (_ctx.showHistory(slotProps.data))
                        }, null, 8, ["onClick"])
                      ], 64))
                    : (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        icon: "pi pi-eye",
                        class: "p-button-rounded p-button-success p-mr-2",
                        style: {"margin-left":"auto"},
                        onClick: ($event: any) => (_ctx.showHistory(slotProps.data))
                      }, null, 8, ["onClick"]))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["first", "value", "rows", "totalRecords", "rowClass", "onPage"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_Button, {
        class: "p-col p-button-success b-style",
        icon: "pi pi-home",
        label: "HOME (Esc)",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.redirectHome())),
        id: "homeBtn"
      }),
      _createElementVNode("span", _hoisted_15, [
        _hoisted_16,
        _hoisted_17,
        _createElementVNode("b", null, _toDisplayString(_ctx.selectedDateLabel), 1)
      ]),
      _createElementVNode("span", _hoisted_18, [
        _hoisted_19,
        _hoisted_20,
        _createElementVNode("b", null, "# " + _toDisplayString(_ctx.pendingCount), 1)
      ]),
      _createElementVNode("span", _hoisted_21, [
        _hoisted_22,
        _hoisted_23,
        _createElementVNode("b", null, "# " + _toDisplayString(_ctx.completedCount), 1)
      ]),
      _createElementVNode("span", _hoisted_24, [
        _hoisted_25,
        _hoisted_26,
        _createElementVNode("b", null, "# " + _toDisplayString(_ctx.allLists.length), 1)
      ])
    ]),
    _createVNode(_component_PaymentScreen, {
      receiptDetail: {
                dialogStatus:      _ctx.paymentDialog,
                itemSource:        'INE',
                restriction:       'No',
                paymentOptionType: 'Cashier',
                cashPayment:       true,
                cardPayment:       true,
                bankTransferPayment: true,
                payLater: (() => {
                    if (!_ctx.currentCart) return false;
                    if (_ctx.currentCart.customer_id !== 1 && _ctx.currentCart.customer_id !== 0) return true;
                    const hasName = _ctx.currentCart.customer_name && 
                                    _ctx.currentCart.customer_name.trim() !== '' && 
                                    _ctx.currentCart.customer_name !== 'Walk In';
                    const hasTel  = _ctx.currentCart.customer_tel && 
                                    _ctx.currentCart.customer_tel.trim() !== '';
                    return hasName || hasTel;
                })(),
                dialogTitle:       'Token Payment - Queue #' + _ctx.currentDisplayNumber,
                customerID:        _ctx.currentCart ? _ctx.currentCart.customer_id : 0,
                customerName:      _ctx.currentCart ? _ctx.currentCart.customer_name : '',
                closeConfirmation: true,
                showQueueOption:   false,
            },
      onClosePaymentScreenEvent: _ctx.closePaymentScreen,
      onGetProceededPaymentsEvent: _ctx.processPayment
    }, null, 8, ["receiptDetail", "onClosePaymentScreenEvent", "onGetProceededPaymentsEvent"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.conflictPopup,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.conflictPopup) = $event)),
      style: { width: '550px' },
      header: "Stock Conflict",
      modal: true,
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel Order",
          icon: "pi pi-times",
          class: "p-button-danger",
          onClick: _ctx.onConflictCancel
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "OK",
          icon: "pi pi-check",
          class: "p-button-warning",
          onClick: _ctx.onConflictOk,
          autoFocus: ""
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("span", null, _toDisplayString(_ctx.conflictMessage), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.cancelConfirmPopup,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cancelConfirmPopup) = $event)),
      style: { width: '450px' },
      header: "Confirm Cancel",
      modal: true,
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No, Go Back",
          icon: "pi pi-arrow-left",
          class: "p-button-success",
          onClick: _ctx.onCancelConfirmNo
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Yes, Cancel Order",
          icon: "pi pi-trash",
          class: "p-button-danger",
          onClick: _ctx.onCancelConfirmYes
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_29
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.tokenHistoryDialog,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tokenHistoryDialog) = $event)),
      style: { width: '100vw' },
      position: "top",
      class: "p-fluid p-m-0 p-dialog-maximized"
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", _hoisted_30, " Token History — #" + _toDisplayString(_ctx.historyToken ? String(_ctx.historyToken.display_number) : '') + " " + _toDisplayString(_ctx.historyToken ? '(' + _ctx.historyToken.token_number + ')' : ''), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.historyToken)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createVNode(_component_DataTable, {
                value: _ctx.tokenActivityRows,
                class: "p-datatable-sm p-datatable-striped p-datatable-gridlines p-mb-4"
              }, {
                empty: _withCtx(() => [
                  _hoisted_32
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, { header: "Event" }, {
                    body: _withCtx((slotProps) => [
                      _createElementVNode("span", {
                        class: _normalizeClass('status-badge status-' + slotProps.data.statusClass)
                      }, _toDisplayString(slotProps.data.event), 3)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Last Accessed By" }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.by), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Time" }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.time), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Account Title" }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.historyToken.customer_name || 'Walk In'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Total Amount" }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(slotProps.data.total).toFixed(2)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Items" }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.items?.length || 0) + " item(s) ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.validationPopup,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.validationPopup) = $event)),
      style: { width: '600px' },
      header: "Confirm"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Close (Esc)",
          icon: "pi pi-close",
          id: "closePopup",
          class: "p-button-danger",
          onClick: _ctx.closeValidationPopup,
          onKeydown: [
            _withKeys(_withModifiers(_ctx.closeValidationPopup, ["prevent"]), ["enter"]),
            _withKeys(_withModifiers(_ctx.closeValidationPopup, ["prevent"]), ["escape"])
          ],
          autoFocus: ""
        }, null, 8, ["onClick", "onKeydown"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("span", null, _toDisplayString(_ctx.validationPopupMessage), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}